// removed by extract-text-webpack-plugin
module.exports = {"item":"styles__item___zv-IC","name":"styles__name___1KdiL","value":"styles__value___1NxOC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Item/styles.scss
// module id = 428
// module chunks = 0